<template>
    <div>
        <b-table
            id="marketOverviewTable"
            :items="table"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            striped
            responsive="sm"
            hover>

            <template v-slot:cell(mk_stake)="row">
                {{ row.item.mk_stake | currency(symbol) }}
            </template>

            <template v-slot:cell(mk_result)="row">
                <span :class="{'text-success': row.item.mk_result > 0, 'text-muted': row.item.mk_result === 0, 'text-danger': row.item.mk_result < 0}">
                    {{ row.item.mk_result | currency(symbol) }}
                </span>
            </template>

            <template v-slot:cell(roi)="row">
                <span :class="{'text-success': row.item.roi > 0, 'text-muted': row.item.roi === 0, 'text-danger': row.item.roi < 0}">
                    {{ row.item.roi | number('0.00') }} %
                </span>
            </template>

            <template v-slot:cell(avg_revenue)="row">
                <span :class="{'text-success': row.item.avg_revenue > 0, 'text-muted': row.item.avg_revenue === 0, 'text-danger': row.item.avg_revenue < 0}">
                    {{ row.item.avg_revenue | currency(symbol) }}
                </span>
            </template>

        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="marketOverviewTable"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    props: ['table', 'currency', 'symbol'],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            sortBy: 'operations',
            sortDesc: true,
            fields: [
                { key: 'name', label: this.__('reports.Market'), sortable: true },
                { key: 'total_bets', label: this.__('reports.Bets'), sortable: true },
                { key: 'mk_stake', label: this.__('reports.Invested'), sortable: true },
                { key: 'mk_result', label: this.__('reports.Result'), sortable: true },
                { key: 'roi', label: this.__('reports.ROI'), sortable: true },
                { key: 'avg_revenue', label: this.__('reports.Average Result'), sortable: true },
                // { key: 'actions', label: this.__('reports.Actions') },
            ],
        }
    },
    computed: {
        rows() {
            return this.table.length
        }
    }
}
</script>

<style scoped>

</style>
